import React from "react";
import { MaskedWords, Reveal } from "../components/Reveal";
import { EDUCATION } from "../data/content";
import { Star, Sun } from "../components/Scribbles";

export default function Education() {
  return (
    <div className="px-5 md:px-10 pt-32 pb-28" data-testid="education-page">
      <header className="max-w-5xl mb-20 relative">
        <p className="font-handwritten text-3xl text-terracotta mb-4 rotate-[-2deg]">where it began</p>
        <h1 className="font-serif font-light text-6xl md:text-8xl uppercase tracking-tighter text-ink leading-none">
          <MaskedWords text="Education" />
        </h1>
        <Sun size={64} className="absolute top-0 right-4 hidden md:block" />
      </header>

      <div className="grid md:grid-cols-1 gap-8 max-w-3xl">
        {EDUCATION.map((edu, i) => (
          <Reveal key={i} delay={i * 0.1}>
            <div className="border-2 border-ink p-8 md:p-12 h-full bg-sand relative" data-testid={`education-${i}`}>
              <Star size={24} className="absolute top-6 right-6" />
              <p className="text-xs uppercase tracking-widest text-terracotta">{edu.period}</p>
              <h2 className="font-serif text-3xl md:text-4xl text-ink mt-4 leading-tight">
                {edu.school}
              </h2>
              <p className="font-serif italic text-xl text-ink/70 mt-2">{edu.degree}</p>
              <p className="text-base text-muted-foreground mt-6 leading-relaxed">{edu.note}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
